import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Capacitor } from '@capacitor/core';
import { faEye, faEyeSlash } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'mom-form-field-input',
  templateUrl: './form-field-input.component.html',
  styleUrls: ['./form-field-input.component.scss']
})
export class FormFieldInputComponent implements OnInit {
  @Input() formCtrl: FormControl;
  @Input() label: string;
  @Input() labelPosition: 'fixed' | 'floating' | 'stacked' = 'floating';
  @Input() pattern: string; // TODO: Should this be set on the FormControl validator?
  @Input() required: boolean;
  @Input() type = 'text';
  @Input() capOption: 'words' | 'off' | 'on' | 'sentences' | 'characters' | 'none' = 'words';
  @Input() enterkeyhint: 'go' | null = null;
  @Input() helper: string;

  @Output() input = new EventEmitter<Event>();
  @Output() keyupEnter = new EventEmitter<void>();

  showPasswordIcon: boolean;
  showPasswordTextInd: boolean;

  faEye = faEye;
  faEyeSlash = faEyeSlash;

  ngOnInit(): void {
    this.showPasswordIcon = this.type === 'password' && Capacitor.getPlatform() !== 'web';
  }

  onClickPasswordIcon(): void {
    this.showPasswordTextInd = !this.showPasswordTextInd;
    this.type = this.showPasswordTextInd ? 'text' : 'password';
  }
}
